module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire-7c35363169687f55cf94b3246b9b7534.svg";